const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;
let lastTrackedPath = '';
let warnedMissingId = false;

export function initializeAnalytics() {
  if (initialized) return;
  if (!GA_MEASUREMENT_ID) {
    if (!warnedMissingId && typeof console !== 'undefined') {
      console.warn('GA測定IDが未設定です。REACT_APP_GA_MEASUREMENT_ID を設定してください。');
      warnedMissingId = true;
    }
    return;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const scriptId = 'ga4-script';
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  if (typeof window.gtag !== 'function') {
    window.gtag = gtag;
  }

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
  initialized = true;
}

export function trackPageView(pagePath) {
  if (!GA_MEASUREMENT_ID) return;
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  if (pagePath === lastTrackedPath) return;

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_title: document.title,
    page_location: window.location.href
  });

  lastTrackedPath = pagePath;
}
